import type { EditControlProps } from '../../declare'
import { Switch } from 'antd'

const SwitchControl = (props: EditControlProps) => {
  const handleChange = (checked: boolean) => {
    props.onChange?.(checked)
  }

  const { __READONLY__, EDITABLE } = props.config

  return (
    <Switch
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      checked={props.value}
      onChange={handleChange}
    />
  )
}

export default SwitchControl
